<ul class="typography typography-headline markerlist markerlist-bullet">
  <li *ngFor="let item of items">
    {{ item }}
  </li>
</ul>
